<template>
  <div class="container-fluid">
    <!--    <Breadcrumbs main="Starter Kit" />-->

    <div ref="screenshotTarget" class="row contract-layout starter-main body-mobile-gen">
      <div class="col-sm-12">
        <div class="card" style="margin-top: 20px">
          <div class="card-header">
            <div class="p-2">
              <div class="row">
                <span>Total Management KPI Score <br /> </span>
                <!-- <p style="font-size: 0.8rem; color: #b9b9b9">
                  Last Updated: {{ lastUpdate }}
                </p> -->
              </div>
              <div class="row">
                <h2>
                  <span style="font-weight: bold; color: #52cf8b">{{
                    kpi.substring(0, kpi.indexOf("/"))
                  }}</span
                  ><span style="font-weight: bold"
                    >/{{ kpi.split("/").pop() }}</span
                  >
                </h2>
              </div>
            </div>
            <div class="card-header-right prod-mobile" style="top: 17px">
              <div class="row center-jst">
                <div class="prod-mobile" :class="list ? 'col-8' : 'col-7'">
                  <div class="gm-mobile row">
                    <!-- <div class="col">
                      <select
                        class="form-select custom_select"
                        style="color: #c2c2c2; line-height: 1"
                      >
                        <option value="all" selected>March 2023</option>
                        <option>January 2023</option>
                        <option>February 2023</option>
                      </select>
                    </div> -->
                    <div class="col">
                      <button
                        v-if="list"
                        type="button"
                        class="button-report"
                        @click="changeView()"
                        style="width: 160px"
                      >
                        Summary View <img src="@/assets/images/summary.svg" />
                      </button>
                      <button
                        v-else
                        type="button"
                        class="button-report"
                        @click="changeView()"
                      >
                        Report View <img src="@/assets/images/list.svg" />
                      </button>
                    </div>
                    <div
                      v-if="list"
                      style="
                        font-weight: 500;
                        color: #9f9f9f;
                        margin-right: 10px;
                      "
                      class="col"
                    >
                      Polarity
                    </div>

                    <div v-if="list" class="col">
                      <span style="color: #9f9f9f">Achievement</span>
                    </div>
                    <!-- <div class="col">
                      <button type="button" class="button-report">
                        Download <img src="@/assets/images/download_down.svg" />
                      </button>
                    </div>
                    <div class="col">
                      <button type="button" class="button-report">
                        Print <img src="@/assets/images/print.svg" />
                      </button>
                    </div> -->
                  </div>
                  <div
                    style="display: flex"
                    class="list-mobile pt-2 pull-right"
                  >
                    <div v-if="list" style="font-weight: 500; display: flex">
                      <img
                        src="@/assets/images/caret_up.svg"
                        style="margin-right: 5px; height: 18px"
                      />
                      Positf
                    </div>
                    <div
                      v-if="list"
                      style="font-weight: 500; display: flex; margin-right: 5px"
                    >
                      <img
                        src="@/assets/images/caret_down.svg"
                        style="margin-right: 5px; height: 18px"
                      />Negatif
                    </div>
                    <div class="center-kit" v-if="!list">
                      <span style="color: #9f9f9f; margin-right: 10px"
                        >Achievement</span
                      >
                    </div>
                    <div class="center-jst" style="display: flex">
                      <span
                        style="background-color: #818181"
                        class="badge rounded-pill text-white"
                        >Not Started</span
                      >
                      <span class="badge rounded-pill data-red">< 95%</span>
                      <span class="badge rounded-pill data-warning"
                        >95-99%</span
                      >
                      <span class="badge rounded-pill data-green">>=100%</span>
                    </div>
                  </div>
                </div>
                <div
                  class="gm-mobile mt-mobile"
                  :class="list ? 'col-4' : 'col-5'"
                >
                  <router-link
                    class="sidebar-link sidebar-title card-hover"
                    to="/summary"
                  >
                    <div
                      @mouseover="hover"
                      @mouseleave="afterHover"
                      class="card-hover"
                      style="
                        border: 1px solid lightgrey;
                        height: 100%;
                        border-radius: 10px;
                        cursor: pointer;
                      "
                    >
                      <div
                        class="text-hover"
                        style="margin-top: 3%; padding-left: 3px; display: flex"
                      >
                        <!-- <img src="@/assets/images/direction_summary.svg" /> -->
                        <svg
                          style="width: 50px; height: 40px"
                          class="m-l-10 fill-icon"
                        >
                          <use
                            v-if="!isHovered"
                            href="@/assets/svg/icon-sprite.svg#cam-dash"
                          ></use>
                          <use
                            v-if="isHovered"
                            href="@/assets/svg/icon-sprite.svg#cam-dash-blue"
                          ></use>
                        </svg>
                        <div
                          class="text-hover"
                          style="
                            color: #b9b9b9;
                            font-weight: 500;
                            margin-left: 5px;
                          "
                        >
                          Cross-Directorate Summary
                        </div>
                        <div>
                          <svg
                            style="width: 20px; height: 40px"
                            class="fill-icon m-r-10"
                          >
                            <use
                              v-if="!isHovered"
                              href="@/assets/svg/icon-sprite.svg#vector-right"
                            ></use>
                            <use
                              v-if="isHovered"
                              href="@/assets/svg/icon-sprite.svg#vector-right-blue"
                            ></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <table v-if="list" class="table">
            <thead>
              <tr>
                <th scope="col" style="text-align: center">No.</th>
                <th scope="col" style="width: 400px">
                  Key Performance Indicator
                </th>
                <th scope="col">Polarity</th>
                <th scope="col">Weight</th>
                <th scope="col">Unit</th>
                <th scope="col">2024 Target</th>
                <th scope="col">YTD Target</th>
                <th scope="col">YTD Realization</th>
                <th scope="col">Achievement (%)</th>
                <th scope="col">Value</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody v-for="(item, id) in dataContract" :key="id">
              <tr
                v-if="
                  item.achievement === null &&
                  item.weight !== null &&
                  item.numberId === '' &&
                  item.metricId !== 'MANAGEMENT_CONTRACT_TOTAL'
                "
              >
                <th style="background-color: #d1dfe5; text-align: center">
                  {{ item.numberId }}
                </th>
                <td colspan="1" style="background-color: #d1dfe5">
                  {{ item.metricName }}
                </td>
                <td colspan="1" style="background-color: #d1dfe5"></td>
                <td colspan="6" style="background-color: #d1dfe5">
                  {{ item.weight }}
                </td>
                <td colspan="2" style="background-color: #d1dfe5">
                  {{ item.value }}
                </td>
                <td colspan="1" style="background-color: #d1dfe5"></td>
              </tr>
              <tr v-if="item.achievement === null && item.weight === null">
                <th style="background-color: #f6faff"></th>
                <td colspan="12" style="background-color: #f6faff">
                  {{ item.metricName }}
                </td>
              </tr>
              <tr
                v-if="
                  item.numberId !== '' &&
                  item.metricId !== 'MANAGEMENT_CONTRACT_TOTAL'
                "
              >
                <th>{{ item.numberId }}</th>
                <td>{{ item.metricName }}</td>
                <td>
                  <img
                    v-if="item.polarity === 'max'"
                    src="@/assets/images/caret_up.svg"
                    style="margin-right: 5px"
                  />
                  <img
                    v-else
                    src="@/assets/images/caret_down.svg"
                    style="margin-right: 5px"
                  />
                </td>
                <td>{{ item.weight }}</td>
                <td>{{ item.unit }}</td>
                <td>{{ item.valueTarget }}</td>
                <td>{{ item.ytdTarget }}</td>
                <td>{{ item.ytdRealization }}</td>
                <td>{{ item.achievement }}</td>
                <td>{{ item.value }}</td>
                <td v-if="item.color === 'green'">
                  <img src="@/assets/images/green_o.svg" />
                </td>
                <td v-if="item.color === 'red'">
                  <img src="@/assets/images/red_o.svg" />
                </td>
                <td v-if="item.color === 'gray'">
                  <img src="@/assets/images/grey_o.svg" />
                </td>
                <td v-if="item.color === 'orange'">
                  <img src="@/assets/images/orange_o.svg" />
                </td>
              </tr>
              <tr
                v-if="
                  item.achievement === null &&
                  item.weight !== null &&
                  item.metricId === 'MANAGEMENT_CONTRACT_TOTAL'
                "
                style="border-bottom-left-radius: 10px; color: white"
              >
                <td
                  colspan="3"
                  style="
                    background-color: #00a3e9;
                    border-bottom-left-radius: 10px;
                    color: white;
                  "
                >
                  Total
                </td>
                <td colspan="6" style="background-color: #00a3e9; color: white">
                  {{ item.weight }}
                </td>
                <td colspan="2" style="background-color: #00a3e9; color: white">
                  {{ item.value }}
                </td>
                <td
                  colspan="1"
                  style="
                    background-color: #00a3e9;
                    border-bottom-right-radius: 10px;
                    color: white;
                  "
                ></td>
              </tr>
            </tbody>
            <tfoot></tfoot>
          </table>
          <div
            v-else
            class="card-body mobile-contract"
            style="background-color: #ebebeb"
          >
            <div
              v-for="(item, id) in dataSummary"
              :key="id"
              class="row"
              style="margin-bottom: 5px"
            >
              <div style="display: flex">
                <div>
                  <div
                    :style="`background-color:${item.avgColor}`"
                    class="kpi-card"
                  >
                    <div
                      class="col-2 alphabet-animation"
                      style="
                        align-content: center;
                        font-size: 21px;
                        font-weight: 700;
                      "
                    >
                      {{ item.alphabet }}
                    </div>
                    <div
                      class="col alphabet-animation"
                      style="
                        align-content: center;
                        padding: 8px;
                        font-size: 14px;
                        font-weight: 700;
                      "
                    >
                      {{ item.metricName }}
                    </div>
                    <div @click="onShowModalDetail(item)" class="button-more">
                      <div>More Details</div>
                    </div>
                    <!-- Modal -->
                    <div
                      class="modal fade"
                      id="modalA"
                      tabindex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog modal-dialog-centered modal-xl">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5
                              class="modal-title"
                              id="exampleModalLabel"
                              style="padding-left: 5px; padding-right: 10px"
                            >
                              A
                            </h5>
                            <div>
                              <div>
                                Nilai Ekonomi dan Sosial untuk Indonesia
                              </div>
                              <div style="font-size: 12px; font-weight: 500">
                                Last Updated: 5 days ago
                              </div>
                            </div>
                            <div
                              class="card-header-right"
                              style="position: absolute; right: 50px"
                            >
                              <div class="row">
                                <div class="col">
                                  <div class="row">
                                    <!--                                    <div class="col"></div>-->
                                    <div
                                      class="col"
                                      style="font-weight: 500; color: #9f9f9f"
                                    >
                                      Polarity
                                    </div>
                                    <div
                                      class="col"
                                      style="font-weight: 500; display: flex"
                                    >
                                      <img
                                        src="@/assets/images/caret_up.svg"
                                        style="margin-right: 5px"
                                      />
                                      Positf
                                    </div>
                                    <div
                                      class="col"
                                      style="font-weight: 500; display: flex"
                                    >
                                      <img
                                        src="@/assets/images/caret_down.svg"
                                        style="margin-right: 5px"
                                      />Negatif<i
                                        class="bi bi-caret-up-fill"
                                      ></i>
                                    </div>
                                    <div class="col">
                                      <span class="badge rounded-pill bg-danger"
                                        >< 95%</span
                                      >
                                    </div>
                                    <div class="col">
                                      <span
                                        class="badge rounded-pill bg-warning text-dark"
                                        >95-99%</span
                                      >
                                    </div>
                                    <div class="col">
                                      <span
                                        class="badge rounded-pill bg-success"
                                        >>=100%</span
                                      >
                                    </div>
                                    <div class="col">
                                      <span
                                        class="badge rounded-pill bg-light text-dark"
                                        >Not Started</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <button
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div class="modal-body">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th scope="col">No.</th>
                                  <th scope="col" style="width: 400px">
                                    Key Performance Indicator
                                  </th>
                                  <th scope="col">Weight</th>
                                  <th scope="col">Unit</th>
                                  <th scope="col">2024 Target</th>
                                  <th scope="col">YTD Target</th>
                                  <th scope="col">YTD Realization</th>
                                  <th scope="col">Achievement (%)</th>
                                  <th scope="col">Value</th>
                                  <th scope="col"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th style="background-color: #f6faff"></th>
                                  <td
                                    colspan="9"
                                    style="background-color: #f6faff"
                                  >
                                    Finansial
                                  </td>
                                </tr>
                                <tr>
                                  <th>1</th>
                                  <td>EBITDA</td>
                                  <td>7</td>
                                  <td>Rp Triliun</td>
                                  <td>101.86</td>
                                  <td>5.05</td>
                                  <td>5.06</td>
                                  <td>100.28%</td>
                                  <td>7.01</td>
                                  <td>
                                    <img src="@/assets/images/green_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th>2</th>
                                  <td>ROIC - WACC</td>
                                  <td>4</td>
                                  <td>%</td>
                                  <td>-1.25</td>
                                  <td>-2.89</td>
                                  <td>-2.65</td>
                                  <td>91.83%</td>
                                  <td>3.67</td>
                                  <td>
                                    <img src="@/assets/images/red_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th>3</th>
                                  <td>Interest Bearing Debt to EBITDA</td>
                                  <td>6</td>
                                  <td>kali</td>
                                  <td>3.99</td>
                                  <td>6.63</td>
                                  <td>6.62</td>
                                  <td>100.28%</td>
                                  <td>6.01</td>
                                  <td>
                                    <img src="@/assets/images/green_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th>4</th>
                                  <td>
                                    Interest Bearing Debt to Invested Capital
                                  </td>
                                  <td>6</td>
                                  <td>%</td>
                                  <td>28.4</td>
                                  <td>29.10</td>
                                  <td>28.45</td>
                                  <td>102.22%</td>
                                  <td>6.13</td>
                                  <td>
                                    <img src="@/assets/images/green_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th>5</th>
                                  <td>
                                    Penyelesaian dan Penyampaian Laporan
                                    Keuangan Audit Tahun 2023
                                  </td>
                                  <td>4</td>
                                  <td>Hari Kerja</td>
                                  <td>5 (setelah SA 600 BPK final)</td>
                                  <td>-</td>
                                  <td>-</td>
                                  <td>-</td>
                                  <td>-</td>
                                  <td>
                                    <img src="@/assets/images/grey_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th style="background-color: #f6faff"></th>
                                  <td
                                    colspan="9"
                                    style="background-color: #f6faff"
                                  >
                                    Operasional
                                  </td>
                                </tr>
                                <tr>
                                  <th>6</th>
                                  <td>Distribution Efficiency Rate</td>
                                  <td>5</td>
                                  <td>%</td>
                                  <td>8.51</td>
                                  <td>8.84</td>
                                  <td>8.84</td>
                                  <td>100%</td>
                                  <td>5.0</td>
                                  <td>
                                    <img src="@/assets/images/green_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th style="background-color: #f6faff"></th>
                                  <td
                                    colspan="9"
                                    style="background-color: #f6faff"
                                  >
                                    Sosial
                                  </td>
                                </tr>
                                <tr>
                                  <th>7</th>
                                  <td>Rasio Elektrifikasi Nasional</td>
                                  <td>5</td>
                                  <td>%</td>
                                  <td>8.51</td>
                                  <td>8.84</td>
                                  <td>8.84</td>
                                  <td>100%</td>
                                  <td>5.0</td>
                                  <td>
                                    <img src="@/assets/images/green_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th>8</th>
                                  <td>
                                    Penyelesaian Roadmap Energy Transition
                                    (Green RUPTL)
                                  </td>
                                  <td>3</td>
                                  <td>Tahapan/ Milestone</td>
                                  <td>Penyelesaian Dokumen RUPTL 2024-2033</td>
                                  <td>
                                    Update jadwal penyusunan Draft RUPTL
                                    2024-2033
                                  </td>
                                  <td>
                                    Update jadwal penyusunan Draft RUPTL
                                    2024-2033
                                  </td>
                                  <td>100%</td>
                                  <td>3.0</td>
                                  <td>
                                    <img src="@/assets/images/green_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th>9</th>
                                  <td>Penyelesaian Program Dedieselisasi</td>
                                  <td>5</td>
                                  <td>Tahapan/ Milestone</td>
                                  <td>Penyelesaian Dokumen RKS Tahap 2</td>
                                  <td>-</td>
                                  <td>
                                    Persiapan penyusunan KKP (verifikasi usulan
                                    lokasi)
                                  </td>
                                  <td>-</td>
                                  <td>-</td>
                                  <td>
                                    <img src="@/assets/images/grey_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th>10</th>
                                  <td>Penyelesaian Program Gasifikasi</td>
                                  <td>5</td>
                                  <td>Tahapan/ Milestone</td>
                                  <td>Pelaksanaan Konstruksi</td>
                                  <td>-</td>
                                  <td>Proses Pembahasan JDA</td>
                                  <td>-</td>
                                  <td>-</td>
                                  <td>
                                    <img src="@/assets/images/grey_o.svg" />
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td
                                    colspan="2"
                                    style="background-color: #d1dfe5"
                                  >
                                    Overall
                                  </td>
                                  <td
                                    colspan="6"
                                    style="background-color: #d1dfe5"
                                  >
                                    50
                                  </td>
                                  <td
                                    colspan="2"
                                    style="background-color: #d1dfe5"
                                  >
                                    xx
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                          <!--                          <div class="modal-footer">-->
                          <!--                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>-->
                          <!--                            <button type="button" class="btn btn-primary">Save changes</button>-->
                          <!--                          </div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-for="(data, id) in item.listChild"
                  :key="id"
                  class="m-l-10"
                >
                  <div class="kpi-group-card">
                    <div style="display: block">
                      <div style="font-size: 12px; font-weight: 700">
                        {{ data.numberRange }}
                      </div>
                      <div style="font-size: 14px; font-weight: 500">
                        {{ data.metricName }}
                      </div>
                      <div
                        style="
                          position: absolute;
                          bottom: 12%;
                          font-size: 14px;
                          font-weight: 500;
                        "
                      >
                        <div style="display: flex">
                          <div
                            v-for="(color, id) in data.listColor"
                            :key="id"
                            style="margin: 2px"
                          >
                            <img
                              v-if="color === 'green'"
                              src="@/assets/images/green_o.svg"
                            />
                            <img
                              v-if="color === 'orange'"
                              src="@/assets/images/orange_o.svg"
                            />
                            <img
                              v-if="color === 'red'"
                              src="@/assets/images/red_o.svg"
                            />
                            <img
                              v-if="color === 'gray'"
                              src="@/assets/images/grey_o.svg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalDetail
      :showModal="modalDetail.show"
      :datas="datas"
      :titleDetail="titleDetail"
      :numeric="numeric"
      @closeModal="onCloseModalDetail"
    />
  </div>
  <!-- </div> -->
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import html2canvas from "html2canvas";

import ManagementContract from "../../services/management-contract/management-contract";
import ModalDetail from "./component/ModalDetail.vue";

const apiContract = ManagementContract.build();
export default {
  components: { ModalDetail },
  data() {
    return {
      kpi: "",
      isHovered: false,
      lastUpdate: "",
      modalDetail: {
        show: false,
        load: false,
      },
      numeric: "",
      datas: "",
      titleDetail: "",
      modal: null,
      list: false,
      dataContract: [],
      resetCounter: 1,
      resetItemIds: [2],
      dataSummary: [],
    };
  },

  mounted() {
    this.$store.commit("updateJudulHalaman", "");
  },

  created() {
    this.getDataContract();
    this.getDataSummaryContract();
    this.getDataSummaryContractDetail();
  },
  computed: {
    ...mapGetters(["shouldTriggerFunction1"]),
  },
  watch: {
    shouldTriggerFunction1(newVal) {
      if (newVal) {
        this.takeScreenshot(); // Call your function here
        this.$store.dispatch("resetTriggerFunction1"); // Reset trigger after calling function
      }
    },
  },
  methods: {
    hover() {
      this.isHovered = true;
    },
    afterHover() {
      this.isHovered = false;
    },
    formatDate(value) {
      return moment(value).format("DD-MM-YYYY hh:mm");
    },
    async takeScreenshot() {
      const targetElement = this.$refs.screenshotTarget;

      try {
        const canvas = await html2canvas(targetElement);
        this.downloadCanvasImage(canvas);
      } catch (error) {
        console.error("Error while taking screenshot:", error);
      }
    },
    downloadCanvasImage(canvas) {
      // Convert canvas to image data URL
      const imgData = canvas.toDataURL("image/png");

      // Create temporary link element
      const downloadLink = document.createElement("a");
      downloadLink.href = imgData;
      downloadLink.download = `PLN Management Contract_${moment(
        new Date()
      ).format("DD-MM-YYYY HH:mm")}.png`;
      document.body.appendChild(downloadLink);

      // Trigger download
      downloadLink.click();

      // Clean up
      document.body.removeChild(downloadLink);
    },
    onCloseModalDetail(value) {
      this.modalDetail.show = value;
    },
    onShowModalDetail(x) {
      this.titleDetail = x.metricName;
      this.datas = x.metricId;
      this.numeric = x.alphabet;
      this.modalDetail.show = true;
    },
    async getDataSummaryContract() {
      const res = await apiContract.getDataSummaryContract();
      const data = res.data.data;
      let alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
      this.lastUpdate = res.data.lastUpdate;
      this.kpi = res.data.totalKpi;
      data.forEach((obj, index) => {
        obj.alphabet = alphabet[index];
      });
      this.dataSummary = data;
    },
    async getDataSummaryContractDetail() {
      const param = {
        parentId: "EKONOMI_SOSIAL",
      };
      const res = await apiContract.getDataSummaryContractDetail(param);
      const data = res.data.data;
    },
    shouldResetNumber(item) {
      return item.achievement === null && item.weight === null;
    },
    resetNumber(x) {
      return this.resetCounter++;
    },
    async getDataContract() {
      const res = await apiContract.getDataContract();
      const data = res.data.data;
      this.dataContract = data;
    },

    addAlphabetProperty(array) {
      let alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

      array.forEach((obj, index) => {
        if (obj.metricId === "EKONOMI_SOSIAL") {
          obj.alphabet = "A";
        } else if (obj.metricId === "INOVASI_MODEL_BISNIS") {
          obj.alphabet = "B";
        } else if (obj.metricId === "KEPEMIMPIAN_TEKNOLOGI") {
          obj.alphabet = "C";
        } else if (obj.metricId === "PENINGKATAN_INVESTASI") {
          obj.alphabet = "D";
        } else if (obj.metricId === "PENGEMBANGAN_TALENTA") {
          obj.alphabet = "E";
        }
      });

      return array;
    },

    onShowModal() {
      this.modal.show();
    },

    changeView() {
      this.list = !this.list;
    },
  },
};
</script>
<style scoped>
.card-hover:hover {
  border: 1px solid #00a3e9 !important;
  color: #00a3e9 !important;
}
.text-hover:hover {
  color: #00a3e9 !important;
}
.data-warning {
  background-color: #ff990040;
  color: #c47500;
}
.data-red {
  background-color: #ff000040;
  color: #ff0b0b;
}
.data-green {
  background-color: #00ff0040;
  color: #00853d;
}
@media screen and (min-width: 1200px) and (max-width: 1400px) {
  .contract-layout {
    zoom: 0.8;
  }
}
@media screen and (min-width: 1500px) and (max-width: 1600px) {
  .contract-layout {
    zoom: 0.9;
  }
}
</style>
